'user strict'
import ex from '../lib/error'
const masterModels = require('../models').masterModels
const ASYNC = require('async')

const createMasterModels = (req, res, next) => {
  masterModels
    .create(req.params)
    .then(masterAuditor => {
      req.responseObject.messageCode = 'MAUD001'
      req.responseObject.data = masterAuditor
      next()
    })
    .catch(error => {
      let errCode
      if (error.name === 'SequelizeUniqueConstraintError') {
        errCode = 'MAUD003'
      } else {
        errCode = 'MAUD004'
      }
      ex.raiseError(req, res, next, errCode, 400, null, error)
    })
}

const getMasterModels = (req, res, next) => {
  masterModels
    .findAll({ where: { userid: req.userid } })
    .then(models => {
      req.responseObject.messageCode = 'MAUD005'
      req.tempStore.models = models
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'MAUD006'
      ex.raiseError(req, res, next, errCode, 400, null, error)
    })
}

const getModelsByName = async (req, res, next) => {
  let modelNames = []

  await ASYNC.forEach(req.body.items, async (row, index) => {
    modelNames.push(row.name);
  })

  masterModels
    .findAll({ where: { userid: req.body.userid, name: modelNames } })
    .then(models => {
      req.tempStore.models = models
      req.tempStore.modelNames = modelNames
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'MAUD006'
      ex.raiseError(req, res, next, errCode, 400, null, error)
    })
}
const createModelsInBulk = (req, res, next) => {
  if (req.tempStore.modelListTobeInserted.length > 0) {
    masterModels.bulkCreate(req.tempStore.modelListTobeInserted, { returning: true })
      .then(models => {
        req.responseObject.data.models = models;
        req.tempStore.models = req.tempStore.models.concat(models);
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'MAUD006'
        ex.raiseError(req, res, next, errCode, 400, null, error)
      });
  } else {
    req.responseObject.data.models = []
    req.tempStore.models = req.tempStore.models
    next()
  }
}
const removeModelsIfPresent = async (req, res, next) => {

  let modelListTobeInserted = []
  if (req.tempStore.models.length > 0) {
    await ASYNC.forEach(req.tempStore.models, async (model, index) => {
      let found = false;
      for (let i = 0; i < req.tempStore.modelNames.length; i++) {
        
        if (req.tempStore.modelNames[i] === model.name) {
          found = true
          break;
        }
      }
      if (!found) {
        modelListTobeInserted.push({ name: model.name, userid: req.body.userid })
      }
    });
  } else {
    for (let i = 0; i < req.tempStore.modelNames.length; i++) {
      modelListTobeInserted.push({ name: req.tempStore.modelNames[i], userid: req.body.userid })
    }
  }

  req.tempStore.modelListTobeInserted = modelListTobeInserted
  next()
}
module.exports = {
  createMasterModels,
  getMasterModels,
  getModelsByName,
  removeModelsIfPresent,
  createModelsInBulk
}